import React from "react";

/**
 * Amazon-style results header with count and sort dropdown
 * Displays results count and sorting options
 */
const ResultsHeader = ({ 
  totalResults, 
  currentStart, 
  currentEnd, 
  sortBy, 
  onSortChange, 
  resultsText 
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-sm p-3 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        {/* Results Count - Amazon style */}
        <div className="text-sm text-gray-700">
          {totalResults > 0 ? (
            <>
              <span className="font-medium">
                {currentStart + 1}-{Math.min(currentEnd, totalResults)}
              </span>
              <span className="mx-1">of</span>
              <span className="font-medium">{totalResults}</span>
              <span className="mx-1">results</span>
              {resultsText && (
                <span>for <span className="font-medium">"{resultsText}"</span></span>
              )}
            </>
          ) : (
            <span>0 results</span>
          )}
        </div>

        {/* Sort Dropdown - Amazon style */}
        <div className="flex items-center gap-2">
          <label htmlFor="sort-select" className="text-sm text-gray-700 whitespace-nowrap">
            Sort by:
          </label>
          <select
            id="sort-select"
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="text-sm border border-gray-300 rounded px-3 py-1.5 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 cursor-pointer"
          >
            <option value="featured">Featured</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
            <option value="rating">Customer Reviews</option>
            <option value="newest">Newest Arrivals</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default ResultsHeader;
